module.exports = __webpack_public_path__ + "img/card-content-1.8ac2e1ec.png";